const execution = {
  id: "execution",
  title: "Execution & On-Ground Control",
  questions: [
    {
      question: "How do you ensure smooth on-ground execution during large movements?",
      answer: "We deploy a dedicated on-site operations team with a predefined execution plan, real-time coordination grid, and central command control for seamless management."
    },
    {
      question: "Will there be a dedicated manager for our group?",
      answer: "Yes. Every project is assigned a dedicated account manager along with on-ground coordinators for complete supervision."
    },
    {
      question: "How do you handle last-minute changes or guest requests?",
      answer: "We maintain buffer vendors, standby vehicles, and flexible coordination systems to adapt instantly without disrupting the schedule."
    },
    {
      question: "Do you manage airport transfers and rooming lists internally?",
      answer: "Yes. Guest movement, room allocation, flight tracking, and transport schedules are centrally managed by our operations team."
    },
    {
      question: "How do you coordinate between hotel, vendors, and production teams?",
      answer: "We operate through a structured command sheet and live coordination workflow to ensure all stakeholders are aligned in real time."
    },
    {
      question: "What measures are taken to avoid execution gaps?",
      answer: "Pre-event recce, detailed SOP checklists, vendor briefings, and timeline rehearsals are conducted before the event goes live."
    },
    {
      question: "Do you provide 24x7 on-ground support during the event?",
      answer: "Yes. Our control desk remains active throughout the event duration for immediate response and issue resolution."
    },
    {
      question: "How do you manage multi-city or back-to-back movements?",
      answer: "Through advance logistics mapping, staggered transport planning, and parallel coordination teams in each destination."
    },
    {
      question: "Can you handle VIP or CXO-level guest management?",
      answer: "Absolutely. We ensure discreet coordination, priority handling, and personalized support for senior leadership guests."
    },
    {
      question: "How do you track overall execution performance?",
      answer: "We monitor operations via real-time checklists, attendance tracking, and post-event audit reports to ensure zero oversight."
    }
  ]
};

export default execution;
